import {
  accountNavigation,
  agentNavigation,
  authNavigation,
  catalogNavigationItems,
  checkoutNavigationItems,
  footerFaqContentIds,
  footerFaqNavItem,
  footerNavigationItemsBase,
  navbarNavigationItemsBase,
  orderNavigation,
  serviceNavigation,
  userHomeContentIds,
  userHomeNavItem,
  userLoginNavItem,
} from './items';
import { devNavigation } from './items/dev';

/* eslint-disable @typescript-eslint/typedef */

export const appNavigationItems = {
  catalog: catalogNavigationItems,
  checkout: checkoutNavigationItems,
  footer: footerNavigationItemsBase,
  navbar: navbarNavigationItemsBase,
  orders: orderNavigation,
  account: accountNavigation,
  auth: authNavigation,
  service: serviceNavigation,
  dev: devNavigation,
  agent: agentNavigation,
} as const;

export const appNavigationSpecialItems = {
  login: userLoginNavItem,
  home: userHomeNavItem,
  faq: footerFaqNavItem,
} as const;

export const appNavigationSpecialItemsIds = {
  home: userHomeContentIds,
  faq: footerFaqContentIds,
} as const;
